"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BLOG_POST = void 0;
var BLOG_POST = 'BlogPost';
exports.BLOG_POST = BLOG_POST;